/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import $ from 'jquery';
import React, {ReactElement} from 'react';
import ReactDOM from 'react-dom';
import _ from 'underscore';

import BenchlingConfig from 'BenchlingConfig';
import * as benchlingUtil from 'BenchlingUtil';
import {BufferContentView, TabOptions} from 'buffers/BufferComps';
import BufferNavItemTemplate from 'buffers/BufferNavItemTemplate';
import * as bufferutil from 'buffers/BufferUtil';
import {
  COPYABLE_FOLDER_ITEMS,
  PRESENCE_ENABLED_FOLDER_ITEMS,
  SHARE_LINK_FOLDER_ITEMS,
} from 'constants/ModelTypeConstants';
import FolderItemState from 'filestate/FolderItemState';
import ResourcePresenceView from 'nav/presence/ResourcePresenceView';
import ShareBar from 'nav/share/ShareBar';
import {BufferState, BufferStates, TabState, TabStates} from 'Navigation';
import BaseEntryProtocolTabState from 'notebook/entries/backbone/tabs/BaseEntryProtocolTab';
import notifications from 'notifications';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';
import EntityStore from 'stores/EntityStore';
import setTestAttrs from 'test/lib/cypress/setTestAttrs';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import {phraseToCamelCase} from 'util/NameUtil';
import {Optional} from 'util/Types';

import DocumentUpdatesManager from '../notebook/realtime/DocumentUpdatesManager';
import PresenceManager from './PresenceManager';

class BufferNavItemView extends Backbone.View<TabState> {
  template!: typeof BufferNavItemTemplate;

  static initClass(): void {
    this.prototype.tagName = 'li';
    this.prototype.className = 'sectionTabs-navItem';
    this.prototype.template = BufferNavItemTemplate;
  }

  toggle(tab: TabState, active: boolean): void {
    if (active) {
      this.$el.addClass('active');
    } else {
      this.$el.removeClass('active');
    }
  }

  _renderCloseIcon(): void {
    if (this.model.get('closeable')) {
      renderToDOM(
        <BenchlingIcon icon="close" className="sectionTabs-navItem-closeBtn-svg" />,
        this.$('.js-sectionTabs-close')[0]
      );
    }
  }

  renderHtml(): void {
    const tabInfo = {...this.model.toJSON()};
    this.$el.attr('data-tab-id', this.model.id);

    const prefKey = this.model.attributes.preferenceKey
      ? phraseToCamelCase(this.model.attributes.preferenceKey)
      : 'noPreferenceKey';
    setTestAttrs(this.$el, {component: 'BufferNavItem', element: 'root', key: prefKey});

    // @ts-expect-error: we sometimes pass JQuery object instead of a string in these calls
    this.$el.html($(this.template(tabInfo)).children());
    this._renderCloseIcon();
  }

  remove(): Backbone.View<TabState> {
    return super.remove();
  }

  render(): this {
    const tab = this.model;
    this.renderHtml();
    if (this.model.get('greyTab')) {
      this.$el.addClass('grey-tab');
    }
    if (this.model.get('active')) {
      this.$el.addClass('active');
    }
    if (!this.model.get('draggable')) {
      this.$el.addClass('no-drag-tab');
    }
    this.$el.data('tab', this.model);

    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(tab, 'change:title', this.renderHtml);
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(tab, 'change:id', this.renderHtml);
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(tab, 'change:closeable', this.renderHtml);
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(this.model, 'change:active', this.toggle);
    const className = tab.get('className');
    if (className != null) {
      this.$el.addClass(className);
    }
    return this;
  }
}

BufferNavItemView.initClass();

// @ts-expect-error: undefined model
class BufferNavView extends Backbone.View<undefined> {
  _eventNamespace!: string;
  viewCache!: Array<BufferNavItemView>;
  $sectionTabs!: JQuery;
  $shareBar!: JQuery;
  ul!: JQuery;
  dropDownEl!: JQuery;
  $nav!: JQuery;
  shareBarMount: Optional<HTMLElement>;
  presenceMount: Optional<HTMLElement>;
  buffer: Optional<BufferState>;
  tabs: Optional<TabStates>;
  fileState: Optional<FolderItemState>;

  static initClass(): void {
    this.prototype.events = {
      // @ts-expect-error
      'click .sectionTabs-navItem': 'onClickTab',
      'click .toggle': 'toggleDropdown',
      'click .overflow-list a': 'hideDropdown',
    };
  }

  initialize(): void {
    this.renderItems = this.renderItems.bind(this);
    this._eventNamespace = `.bufferNavView-${this.cid}`;

    this.viewCache = [];
    this.$sectionTabs = this.$('.buffer-tabs-sectionTabs');
    this.$shareBar = this.$('.buffer-tabs-shareBarMount');
    this.ul = this.$sectionTabs.find('.sectionTabs-nav').eq(0);
    this.dropDownEl = this.$sectionTabs.find('.sectionTabs-moreDropdown').eq(0);
    // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
    document.addEventListener('mousedown', (e: JQueryMouseEventObject) => this.closeFromOutside(e), true);
    // eslint-disable-next-line no-multi-assign
    const $nav = (this.$nav = this.$('.sectionTabs-nav'));

    const that = this;
    this.$nav.sortable({
      placeholder: 'sectionTabs-navItemPlaceholder',
      forcePlaceholderSize: true,
      items: '> li:not(.no-drag-tab)',
      receive(event: JQueryEventObject, ui: JQueryUI.SortableUIParams) {
        const tab = ui.item.data('tab');
        if (tab instanceof BaseEntryProtocolTabState) {
          ui.sender.sortable('cancel');
          notifications.warn('Protocols cannot be moved from the left pane.');
        }
      },
      update(event: JQueryEventObject, ui: JQueryUI.SortableUIParams) {
        // The update event gets called twice: once for source buffer and again for destination buffer.
        // The source case does not need to be handled, so we skip it. See: http://stackoverflow.com/a/7340208
        // @ts-expect-error: TS says this will always be true, I think because of some odd `this` binding
        if (this !== ui.item.parent()[0]) {
          return;
        }

        const tab = ui.item.data('tab');
        const index = ui.item.index();
        _.defer(() => {
          (that.buffer!.collection as BufferStates).moveTab(tab, that.buffer!, index);
          $nav.sortable('refresh');
        });
      },
    });
  }

  onClickTab(e: JQueryEventObject): void {
    const node = $(e.currentTarget);
    const id = node.attr('data-tab-id');
    const tab = this.tabs!.get(id);
    if ($(e.target).closest('.sectionTabs-navItem-closeBtn').length) {
      tab.close();
    } else {
      tab.set('active', true);
    }
    this.hideDropdown();
    tab.onClick();
    e.preventDefault();
  }

  closeFromOutside(e: JQueryMouseEventObject): void {
    const target = $(e.target);
    if (target.parents('.sectionTabs-moreDropdown').length === 0) {
      this.hideDropdown();
    }
  }

  hideDropdown(): void {
    this.$('.toggle').removeClass('active');
    this.$('.overflow-list').hide();
  }

  toggleDropdown(): void {
    this.$('.toggle').toggleClass('active');
    this.$('.overflow-list').toggle();
  }

  ulWidth(): number {
    // Note: We can't use $ul.width() because the UL has {flex: 1} to ensure that it has full width so that
    // tab drag-and-drop works properly.
    let width = 0;
    this.ul.find('li').each(function () {
      // @ts-expect-error: this errors but I don't want to deal with `this` binding
      width += $(this).outerWidth(true);
    });
    return width;
  }

  renderItems(): void {
    while (this.viewCache.length > 0) {
      this.viewCache.pop()!.remove();
    }

    this.tabs!.each((tab) => {
      if (!tab.showInNavBar()) {
        return;
      }
      const item = new BufferNavItemView({model: tab});
      this.viewCache.push(item);
      this.ul.append(item.render().el);
    });

    // Avoid .overflow styling from affecting the following computation.
    this.$sectionTabs.removeClass('overflow');
    this.$('.overflow-list').empty();
    // Move tabs out until it's okay.
    while (
      this.ulWidth() > this.$el.width() - this.dropDownEl.width() - this.$shareBar.width() &&
      this.ul.children().not('.active').length > 0
    ) {
      const li = this.ul.children().not('.active').last().addClass('sectionTabs-navItem--overflow').detach();
      this.$('.overflow-list').append(li);
    }
    this.$sectionTabs.toggleClass('overflow', this.$('.overflow-list li').length > 0);

    this.$nav.sortable('refresh');
  }

  handleTabDrag(): void {
    if (this.buffer!.get('shareTabsWithOtherBuffers')) {
      this.$nav.sortable({connectWith: '.sectionTabs-nav.js-share-tabs'});
    }
    this.$nav.toggleClass('js-share-tabs', this.buffer!.get('shareTabsWithOtherBuffers'));
  }

  // @ts-expect-error
  remove(): Backbone.View<undefined> {
    this.unmountShareBar();
    $(window).off(this._eventNamespace);
    return super.remove();
  }

  mountShareBar(): void {
    const shareBarMount = this.$('.buffer-tabs-shareBarMount')[0];
    if (shareBarMount == null || EntityStore.currentUser() == null) {
      return;
    }

    const fileType = this.fileState!.fileType();
    if (!SHARE_LINK_FOLDER_ITEMS.includes(fileType) && !COPYABLE_FOLDER_ITEMS.includes(fileType)) {
      this.unmountShareBar();
      return;
    }
    const file = this.fileState!.model();

    renderToDOM(
      <ShareBar
        fileId={file.id}
        fileName={file.name()}
        fileType={fileType}
        onDuplicate={file.duplicate?.bind(file)}
        filePerms={file.permissions()}
      />,
      shareBarMount
    );
    this.shareBarMount = shareBarMount;
  }

  unmountShareBar(): void {
    if (this.shareBarMount != null) {
      ReactDOM.unmountComponentAtNode(this.shareBarMount);
    }
  }

  mountPresenceView(): void {
    const presenceMount = this.$('.buffer-tabs-presenceMount')[0];
    if (
      presenceMount == null ||
      EntityStore.currentUser() == null ||
      !BenchlingConfig.ELN_ENABLE_REALTIME_UPDATES_M1 ||
      !PRESENCE_ENABLED_FOLDER_ITEMS.includes(this.fileState!.fileType())
    ) {
      this.unmountPresenceView();
      return;
    }

    const file = this.fileState!.model();

    renderToDOM(<ResourcePresenceView resourceId={file.id} />, presenceMount);
    this.presenceMount = presenceMount;
  }

  unmountPresenceView(): void {
    if (this.presenceMount != null) {
      ReactDOM.unmountComponentAtNode(this.presenceMount);
    }
  }

  isRightmostBuffer(): boolean {
    if (this.buffer == null) {
      return false;
    }
    const numActive = this.buffer.collection.where({active: true}).length;
    const index = this.buffer.collection.indexOf(this.buffer);
    return (numActive === 1 && index === 0) || index === 1;
  }

  isWideBuffer(): boolean {
    return this.buffer!.collection.where({active: true}).length === 1;
  }

  update(buffer: BufferState, fileState: FolderItemState): void {
    $(window).off(this._eventNamespace);
    // eslint-disable-next-line @typescript-eslint/unbound-method
    $(window).on(`resize${this._eventNamespace}`, benchlingUtil.resizeThrottler(this.renderItems));
    // eslint-disable-next-line @typescript-eslint/unbound-method
    $(window).on(`buffersResize${this._eventNamespace}`, this.renderItems);

    if (this.buffer != null) {
      this.stopListening(this.buffer);
    }
    this.buffer = buffer;
    this.fileState = fileState;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(this.buffer, 'change:shareTabsWithOtherBuffers', this.handleTabDrag);

    if (this.tabs != null) {
      this.stopListening(this.tabs);
    }
    this.tabs = this.buffer.get('tabs');
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(this.tabs, 'add remove reset', this.renderItems);

    if (this.isRightmostBuffer()) {
      this.mountPresenceView();
      this.mountShareBar();
    } else {
      this.unmountPresenceView();
      this.unmountShareBar();
    }

    this.handleTabDrag();
    this.renderItems();
  }
}

BufferNavView.initClass();

// @ts-expect-error
export class BufferView extends Backbone.View<undefined> {
  content!: BufferContentView;
  menu!: BufferNavView;
  $bufferOptionsReactMount!: JQuery;
  renderedTab!: null | TabState;
  tabs?: TabStates;

  // @ts-expect-error
  initialize(options?: Backbone.ViewOptions<undefined>): void {
    // @ts-expect-error: the Backbone types should really be `render(): this`
    this.menu = new BufferNavView({el: this.$('.buffer-tabs')}).render();
    this.$bufferOptionsReactMount = this.$('.buffer-options-reactMount');
    this.content = new BufferContentView({el: this.$('.buffer-content')});
    this.renderedTab = null;
  }

  renderTabIfActive(tab?: TabState, shouldForceUpdate: boolean = false): void {
    if (tab == null || !tab.get('active')) {
      return;
    }
    // allow force update for webpack HMR
    if (shouldForceUpdate || this.renderedTab !== tab) {
      const tabstateViews = bufferutil.getView(tab);
      this.content.update(tab, tabstateViews.TabView);
      if (tabstateViews.OptionsView != null) {
        renderToDOM(
          <TabOptions tabState={tab} TabOptionsViewCls={tabstateViews.OptionsView} />,
          this.$bufferOptionsReactMount[0]
        );
      } else {
        renderToDOM(
          <TabOptions tabState={null} TabOptionsViewCls={null} />,
          this.$bufferOptionsReactMount[0]
        );
      }
      this.$el.toggleClass('grey-tab-view', tab.get('greyTab'));
      this.$el.toggleClass('hide-options-view', tabstateViews.OptionsView == null);
      setTestAttrs(this.$el, tabstateViews.dataTestAttrs);

      // Trigger resize event in case options view gets hidden / appears.
      $(window).trigger('buffersResize');
      this.renderedTab = tab;
    }
  }

  renderEmpty(): void {
    if (this.tabs!.size() === 0) {
      this.clearTab();
    }
  }

  clearTab(): void {
    this.content.update(null, null);
    renderToDOM(<TabOptions tabState={null} TabOptionsViewCls={null} />, this.$bufferOptionsReactMount[0]);
    this.renderedTab = null;
  }

  updateBufferAndActiveClass(buffer: BufferState, numActive: number, fileState: FolderItemState): void {
    // If the tab has changed, let's clear the tab first, to ensure we restore
    // the tab with the correct buffer size.
    if (this._activeTab(buffer) !== this.renderedTab) {
      this.clearTab();
    }

    // Update the classes
    this.$el.removeClass('full-width');
    this.$el.removeClass('invisible');
    this.$el.removeClass('vertical-split');
    if (buffer.get('active')) {
      if (numActive === 1) {
        this.$el.addClass('full-width');
      } else if (numActive === 2) {
        this.$el.addClass('vertical-split');
      }
      $(window).trigger('buffersResize');
    } else {
      this.$el.addClass('invisible');
    }

    // Update the tab
    this.update(buffer, fileState);
  }

  _activeTab(buffer: BufferState): TabState | undefined {
    return buffer.get('tabs').find((t: TabState) => t.get('active'));
  }

  update(buffer: BufferState, fileState: FolderItemState): void {
    if (this.tabs != null) {
      this.stopListening(this.tabs);
    }
    this.tabs = buffer.get('tabs');
    this.menu.update(buffer, fileState);

    // Activate a tab if there is no active tab
    if (this.tabs!.size() !== 0 && !this._activeTab(buffer)) {
      this.tabs!.at(0).set('active', true);
    }

    this.listenTo(this.tabs, 'add change:active', (tab: TabState) => {
      this.renderTabIfActive(tab);
    });
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(this.tabs, 'remove reset', this.renderEmpty);

    const tab = this._activeTab(buffer);
    if (tab != null) {
      this.renderTabIfActive(tab);
    } else {
      this.clearTab();
    }
  }
}

// @ts-expect-error: no model defined
class BuffersView extends Backbone.View<undefined> {
  bufferViews!: Array<BufferView>;
  hasReactMounted!: boolean;
  buffers: Optional<BufferStates>;
  fileState!: null | FolderItemState;
  $tabNavbars!: JQuery;
  $containers!: JQuery;
  $reactMount!: JQuery;
  presenceManager!: PresenceManager;
  documentUpdatesManager!: DocumentUpdatesManager;

  static initClass(): void {
    this.prototype.el = '#buffers';
  }

  // @ts-expect-error
  initialize(options?: Backbone.ViewOptions<undefined>): void {
    this.bufferViews = Array.from(this.$('.buffer-container')).map(
      (bufferEl) => new BufferView({el: bufferEl})
    );
    this.hasReactMounted = false;
    this.buffers = null;
    this.fileState = null;
    this.$tabNavbars = this.$('.buffer-tabs');
    this.$containers = this.$('.buffer-container');
    this.$reactMount = this.$('.buffer-reactMount');
    this.presenceManager = new PresenceManager(this.$('.buffer-presenceManagerMount'));
    this.documentUpdatesManager = new DocumentUpdatesManager();
  }

  update(fileState: FolderItemState | null, reactComponent: ReactElement<unknown> | null = null): void {
    // Clean up previous render
    if (this.buffers != null) {
      this.stopListening(this.buffers);
    }
    if (reactComponent == null && this.hasReactMounted) {
      ReactDOM.unmountComponentAtNode(this.$reactMount[0]);
    }
    if (fileState == null && this.buffers != null) {
      for (const bufferView of this.bufferViews) {
        bufferView.clearTab();
      }
    }
    this.presenceManager.unsubscribe();
    this.documentUpdatesManager.changeActiveDocument(fileState);

    // Update internal state
    this.hasReactMounted = reactComponent != null;
    this.buffers = fileState != null ? fileState.buffers() : undefined;
    this.fileState = fileState;

    // Re-render
    this.$el.toggleClass('empty', fileState == null && reactComponent == null);
    this.$tabNavbars.toggleClass('hidden', fileState != null && fileState.get('hideTabNav'));
    this.$containers.toggleClass('hidden', fileState == null);
    this.$reactMount.toggleClass('hidden', reactComponent == null);
    if (fileState != null) {
      this.listenTo(this.buffers, 'change add remove', () => this.render());
      this.render();
      this.presenceManager.subscribe(this.fileState);
    } else if (reactComponent != null) {
      renderToDOM(reactComponent, this.$reactMount[0]);
    }
  }

  /*
   * Render the current fileState's BufferStates Collection. Assume that the collection size always matches
   * the length of `this.bufferViews`. Currently, this count in the collection is always 2, which is generally
   * constructed in the initialize() method of a FileState model, like `FolderItemState.initialize()`,
   * and corresponds to the number of .buffer-container DOM elements created by the editor.jade template,
   * referenced as `this.bufferViews` in this view.
   */
  render(): this {
    const buffers = this.buffers!.models;
    const numActive = buffers.filter((buffer) => buffer.get('active')).length;
    for (const [i, buffer] of buffers.entries()) {
      this.bufferViews[i].updateBufferAndActiveClass(buffer, numActive, this.fileState!);
    }
    return this;
  }
}

BuffersView.initClass();

export default BuffersView;
